import { render, staticRenderFns } from "./CoinSessionDialog.vue?vue&type=template&id=59ceea34&scoped=true&"
import script from "./CoinSessionDialog.vue?vue&type=script&lang=js&"
export * from "./CoinSessionDialog.vue?vue&type=script&lang=js&"
import style0 from "./CoinSessionDialog.vue?vue&type=style&index=0&id=59ceea34&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ceea34",
  null
  
)

export default component.exports